(function () {
  // Infinite scroll for paginated grids/lists (collection, search).
  //
  // Each grid opts in with `data-infinite-scroll` and exposes:
  //   data-has-next-page   "true" | "false"
  //   data-next-url        the {{ paginate.next.url }} (filters/sort/query preserved)
  //   data-item-selector   selector for the items to append (e.g. ".product-card")
  //
  // The next page is fetched via Shopify's Section Rendering API (section_id +
  // the paginate next URL), then matching items are moved into the live grid.

  function initGrid(grid) {
    var shopifySection = grid.closest('.shopify-section');
    var sectionId =
      shopifySection && shopifySection.id
        ? shopifySection.id.replace('shopify-section-', '')
        : null;
    if (!sectionId) return;

    var root = grid.closest('[data-infinite-scroll-root]') || grid.parentElement;
    var sentinel = root.querySelector('[data-infinite-scroll-sentinel]');
    var loading = root.querySelector('[data-infinite-scroll-loading]');
    var itemSelector = grid.getAttribute('data-item-selector') || '.product-card';

    if (!sentinel) return;

    var isFetching = false;
    var abortController = null;

    function hasNextPage() {
      return grid.getAttribute('data-has-next-page') === 'true';
    }

    function setLoading(on) {
      if (loading) loading.classList.toggle('hidden', !on);
    }

    function buildUrl(nextUrl) {
      var url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      return url.toString();
    }

    function stop() {
      grid.setAttribute('data-has-next-page', 'false');
      grid.setAttribute('data-next-url', '');
      sentinel.classList.add('hidden');
      if (observer) observer.disconnect();
    }

    function loadNext() {
      if (isFetching || !hasNextPage()) return;
      var nextUrl = grid.getAttribute('data-next-url');
      if (!nextUrl) {
        stop();
        return;
      }

      isFetching = true;
      setLoading(true);
      abortController = new AbortController();

      fetch(buildUrl(nextUrl), { signal: abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Fetch failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fetchedGrid = doc.querySelector('[data-infinite-scroll]');
          if (!fetchedGrid) {
            stop();
            return;
          }

          var items = fetchedGrid.querySelectorAll(itemSelector);
          items.forEach(function (item) {
            grid.appendChild(document.adoptNode(item));
          });

          if (fetchedGrid.getAttribute('data-has-next-page') === 'true') {
            grid.setAttribute('data-next-url', fetchedGrid.getAttribute('data-next-url') || '');
            grid.setAttribute('data-has-next-page', 'true');
          } else {
            stop();
          }
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          console.error('Infinite scroll error:', err);
        })
        .finally(function () {
          isFetching = false;
          setLoading(false);
          // The sentinel may still be on-screen after a short batch — keep going.
          if (hasNextPage() && observer && isSentinelVisible()) loadNext();
        });
    }

    function isSentinelVisible() {
      var rect = sentinel.getBoundingClientRect();
      return rect.top <= (window.innerHeight || document.documentElement.clientHeight) + 400;
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext();
          });
        },
        { rootMargin: '400px 0px' }
      );
      observer.observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        if (isSentinelVisible()) loadNext();
      });
    }
  }

  document.querySelectorAll('[data-infinite-scroll]').forEach(initGrid);
})();
